'use client'
import { Box, Tooltip, Grid, Typography, Accordion, AccordionSummary, AccordionDetails, Divider, ListItem, ListItemText } from "@mui/material";
import React, { useEffect, useState } from "react";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios'
import { useDispatch } from "react-redux";
import LoadingSpinner from "./LoadingSpinner";
import NoItemsMessage from "./NoItemsMessage";
import { actions as builderActions } from '@/store/builderSlice';
import { accordionTitleConstants } from "./GetTrayComponentsForThreeDBuilder";
import ProductOptionComponent from "../product/product_options";
import useConfigValue from "@/utils/config";
import cssStyles from '../../pages/[vendor]/product/product.module.scss'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { gtmClickTracking } from "@/utils";
import ProductThumbnail from "./ProductThumbnail";
import  ProductFavoriteButton  from '../FavoriteButtons/ProductFavoriteButton'
import {v4 as uuidv4} from 'uuid';
interface ProductDetailsProps {
    handleCloseProductDetails: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId: (itemId: string) => void;
    selectedProductDetailsId: string;
    activeAccordion: any;
    handleActiveAccordion: (obj: any) => void;
    selectedDesignDetailsId: string;
    handleMenuCloseDesignDetail: (isCloseMenu: boolean) => void
    handleMoreItemsClosed: (isCloseMenu: boolean) => void;
}
export const apiStatusConstants = {
    initial: 'INITIAL',
    pending: 'PENDING',
    fulfilled: 'FULFILLED',
    rejected: 'REJECTED'
}
const ProductDetails: React.FC<ProductDetailsProps> = ({ handleCloseProductDetails, handleSelectedProductDetailId, selectedProductDetailsId, activeAccordion, handleActiveAccordion, selectedDesignDetailsId, handleMenuCloseDesignDetail, handleMoreItemsClosed }) => {
    console.log('ProductDetails component start--------------------------------------------------')
    //state
    const [apiStatus, setApiStatus] = useState<string>(apiStatusConstants.initial)
    const [productDetails, setProductDetails] = useState<any>()

    const [showMoreProductInfo, setShowMoreProductInfo] = useState(false);
    const toogleProductInfo = () => {
        setShowMoreProductInfo(!showMoreProductInfo);
    }
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);
    const [expanded, setExpanded] = React.useState<string | false>(false);
    const handleChange =
        (panel: string, sectionName: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);

            // Trigger GTM tracking only when the panel is expanded
            if (isExpanded) {
                gtmClickTracking({
                    event: 'Product_Details_Clicked',
                    section: sectionName,  // Pass the section name dynamically
                    product_id: productDetails?.productId,
                    product_name: productDetails?.productName,
                });
            }
        };
    //utility
    const optionsStyling = useConfigValue('PRODUCT_OPTIONS') as any;
    const productCategorizationData: any = productDetails?.productCategorization ? JSON.parse(productDetails.productCategorization) : null;
    let productCategroizationIndex = 0;
    const dispatch = useDispatch()
    //effects
    useEffect(() => {
        //to fetch design details
        async function fetchData() {
            setApiStatus(apiStatusConstants.pending)
            try {
                const response = await axios.get(`https://d221a61rb87vel.cloudfront.net/v1/api/productDetails?productId=${selectedProductDetailsId}`)
                if (response.data) {
                    const model3dUrl = response.data?.productMetaData?.model3dUrl;
                    if (model3dUrl) {
                        setProductDetails(response.data)
                        dispatch(builderActions.addProductData({ products: [response.data] }))
                        setApiStatus(apiStatusConstants.fulfilled)
                    } else {
                        throw new Error('this product not support 3d')
                    }
                } else {
                    throw new Error('error while fetching data at ProductDetails component')
                }
            } catch (error) {
                console.log(error, 'error while fetching data at ProductDetails component')
                setApiStatus(apiStatusConstants.rejected)
            }

        }
        if (selectedProductDetailsId) {
            fetchData()
        }
    }, [selectedProductDetailsId])
    const getFulfilledView = (productDetails: any) => {
        return (
            <>
                <Box component="div" className="custom_scrollbar" sx={{ overflowY: 'auto', height: 'calc(100% - 50px)', position: 'relative'  }}>
                    <Tooltip title={<Typography fontSize={14} color={'white'}>Drag and drop to add product to the room</Typography>} arrow PopperProps={{ style: { zIndex: 99999999, width: 200, opacity: 0.75 }, modifiers: [{ name: "offset", options: { offset: [0, 0], }, },], }} placement="right">
                        <Box component="span" sx={{ cursor: 'pointer', display: 'block', backgroundColor: 'white' }}>
                            <ProductThumbnail product={{ ...productDetails, ...productDetails?.productMetaData }} changeSize={true} />
                        </Box>
                    </Tooltip>
                    <Box component='div' sx={{ position: 'absolute', left: '10px', top: '10px' }}>
                         <ProductFavoriteButton eachProduct={{ ...productDetails, ...productDetails?.productMetaData }} fontSize='20px' />
                     </Box>
                    {/* <img src={productDetails?.productMetaData?.productImage} alt={productDetails?.productName} style={{ width: '100%', height: '40%', objectFit: 'cover', objectPosition: 'center' }} /> */}
                    <Typography sx={{ fontSize: '16px', padding: '10px 0 0 0', fontWeight: '700' }}>{productDetails?.productName}</Typography>
                    <Typography sx={{ fontSize: '14px' }}>{productDetails?.productSubTypeDisplayName}</Typography>
                    <Box component="div">
                        {
                            productDetails?.productVariants && (
                                Object.keys(productDetails.productVariants).map(key =>
                                    <React.Fragment key={uuidv4()}>
                                        {productDetails.productVariants[key].data.length > 0 && (
                                            <ProductOptionComponent {...{
                                                page: "pdp",
                                                type: optionsStyling[key] ? optionsStyling[key].variation : optionsStyling['default-config'].variation,
                                                selectedProductId: productDetails?.productId,
                                                option: productDetails.productVariants[key],
                                                selectedSize: productDetails?.size,
                                                handleCloseProductDetails: handleCloseProductDetails,
                                                handleSelectedProductDetailId: handleSelectedProductDetailId
                                            }} />
                                        )}
                                    </React.Fragment>
                                )
                            )
                        }

                        {/* Price Display Box */}
                        <Box component="div" className={cssStyles.price} sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                            <Typography sx={{ color: '#000', fontSize: '20px', fontWeight: '700' }}>{parseInt(productDetails?.productMetaData?.comparePrice as any) > parseInt(productDetails?.productMetaData?.price as any) && <Box component="span" sx={{ textDecoration: 'line-through' }}>${productDetails?.productMetaData?.comparePrice}</Box>} <Box component="span" sx={{ color: '#0D908E' }}>${productDetails?.productMetaData?.price}</Box></Typography>

                            {productDetails?.productMetaData?.price > 0 && productDetails?.productMetaData?.comparePrice > 0 && productDetails?.productMetaData?.price < productDetails?.productMetaData?.comparePrice && (
                                <Box component="span" sx={{
                                    color: (theme: { palette: { primary: { main: any; }; }; }) => theme.palette.primary.main,
                                    fontSize: '18px',
                                    textAlign: 'right',
                                    marginLeft: 'auto'
                                }}>
                                    {Math.round(((productDetails?.productMetaData?.comparePrice - productDetails?.productMetaData?.price) / productDetails?.productMetaData?.comparePrice) * 100)}% Off
                                </Box>
                            )}
                        </Box>
                        <Box component="div" sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                            <LocalShippingOutlinedIcon style={{ fontSize: '24px', marginRight: '10px' }} />
                            <span className={cssStyles["delivery-info"]}>Free Shipping! Arrives in less than 2 weeks</span>
                        </Box>
                        {/* About the product */}
                        {true && <div>
                            <Divider sx={{ mt: '20px', mb: '20px' }} />
                            <Box component="div" className={cssStyles["about-product"]}>
                                <h2>About the Product</h2>
                                <Box component="div" sx={{ display: 'flex', marginBottom: '10px' }}><Typography variant="subtitle2" sx={{ fontWeight: 800 }}>Brand</Typography>: {productDetails?.vendorName}</Box>
                                <Box component="div" className={!showMoreProductInfo ? cssStyles.product_desc_collapsed : ''}>{productDetails?.productDetails}</Box>
                                <Box component="div" className={cssStyles.show_more}><a href="javascript:void(0)" onClick={() => toogleProductInfo()} style={{ backgroundColor: 'transparent' }}>{!showMoreProductInfo ? "More +" : "Less -"}</a></Box>
                                <Box component="div" sx={{ mb: '20px' }}></Box>
                                <Box component="div" className={cssStyles["additional-info"]}>
                                    {
                                        productDetails?.productDimentions !== null &&
                                        <Accordion className={cssStyles["additional-info__accordion"]} sx={{ backgroundColor: 'transparent' }}
                                            key={'productDimentions'} expanded={expanded === 'panel-productDimentions'}
                                            onChange={handleChange('panel-productDimentions', 'Product Dimensions')} disableGutters>
                                            <AccordionSummary
                                                expandIcon={expanded === 'panel-productDimentions' ? <RemoveIcon /> : <AddIcon />}
                                            >
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{'Product Dimensions'}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <ul>
                                                    <ListItem key='productHeight' component="li">
                                                        <ListItemText><Typography variant="body2">Height: {productDetails?.productDimentions['height']} inches</Typography></ListItemText>
                                                    </ListItem>
                                                    <ListItem key='productWidth' component="li">
                                                        <ListItemText><Typography variant="body2">Width: {productDetails?.productDimentions['width']} inches</Typography></ListItemText>
                                                    </ListItem>
                                                    <ListItem key='productDepth' component="li">
                                                        <ListItemText><Typography variant="body2">Depth: {productDetails?.productDimentions['depth']} inches</Typography></ListItemText>
                                                    </ListItem>
                                                    <ListItem key='productWeight' component="li">
                                                        <ListItemText><Typography variant="body2">Weight: {productDetails?.productDimentions['weight']} lbs</Typography></ListItemText>
                                                    </ListItem>

                                                </ul>
                                            </AccordionDetails>
                                        </Accordion>
                                    }
                                    {
                                        productCategorizationData !== null && (

                                            Object.keys(productCategorizationData).map(function (key: any, value: any) {
                                                productCategroizationIndex = productCategroizationIndex + 1;
                                                return (
                                                    <Accordion sx={{ backgroundColor: 'transparent' }} className={cssStyles["additional-info__accordion"]} key={productCategroizationIndex} expanded={expanded === `panel${productCategroizationIndex}`} onChange={handleChange(`panel${productCategroizationIndex}`, key)} disableGutters>
                                                        <AccordionSummary
                                                            expandIcon={expanded === `panel${productCategroizationIndex}` ? <RemoveIcon /> : <AddIcon />}
                                                        >
                                                            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{key}</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            {productCategorizationData[key] && (
                                                                <ul>
                                                                    {productCategorizationData[key].map((list: any, index: any) => {
                                                                        return (
                                                                            <ListItem key={index} component="li">
                                                                                <ListItemText><Typography variant="body2">{list}</Typography></ListItemText>
                                                                            </ListItem>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            )}
                                                        </AccordionDetails>
                                                    </Accordion>
                                                )
                                            })
                                        )
                                    }

                                    {isMounted &&
                                        (
                                            <>

                                                {
                                                    productDetails?.assemblyInstructions !== undefined &&
                                                    <Accordion className={cssStyles["additional-info__accordion"]} sx={{ backgroundColor: 'transparent' }}
                                                        key={'assemblyInstructions'} expanded={expanded === 'panel-assemblyInstructions'}
                                                        onChange={handleChange('panel-assemblyInstructions', 'Assembly Instructions')} disableGutters>
                                                        <AccordionSummary
                                                            expandIcon={expanded === 'panel-assemblyInstructions' ? <RemoveIcon /> : <AddIcon />}
                                                        >
                                                            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{'Assembly Instructions'}</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <Typography variant="body2">
                                                                {productDetails?.assemblyInstructions && (
                                                                    <a
                                                                        href={productDetails.assemblyInstructions}
                                                                        target="_blank"
                                                                    >
                                                                        {productDetails.assemblyInstructions}
                                                                    </a>
                                                                )}
                                                            </Typography>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                }

                                                {/* Hard-coded Accordion for Return Policy */}
                                                <Accordion sx={{ backgroundColor: 'transparent' }}
                                                    className={cssStyles["additional-info__accordion"]}
                                                    key={'returnPolicy'}
                                                    expanded={expanded === 'panel-returnPolicy'}
                                                    onChange={handleChange('panel-returnPolicy', 'Return Policy')}
                                                    disableGutters
                                                >
                                                    <AccordionSummary
                                                        expandIcon={expanded === 'panel-returnPolicy' ? <RemoveIcon /> : <AddIcon />}
                                                    >
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{'Return Policy'}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Typography variant="body2">
                                                            <a href="https://nestingale.com/pages/return-policy" target="_blank">https://nestingale.com/pages/return-policy</a>
                                                        </Typography>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </>
                                        )}
                                </Box>
                            </Box>
                        </div>}
                    </Box>
                </Box>
            </>
        );
    }
    function getView(apiStatus: string) {
        switch (apiStatus) {
            case apiStatusConstants.pending:
                return <Box component='div' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}><LoadingSpinner /></Box>
            case apiStatusConstants.fulfilled:
                return getFulfilledView(productDetails)
            case apiStatusConstants.rejected:
                return <Box component='div' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}><NoItemsMessage textToShow="No Product Found" fontSize='16px' /></Box >
            default:
                return null
        }
    }
    //root return of jsx
    return (
        <>
            <Box component="div" sx={{ height: '50px', position: 'relative' }}>
                <KeyboardArrowLeftIcon onClick={() => {
                    handleCloseProductDetails(true)
                    if (selectedDesignDetailsId) {
                        handleMenuCloseDesignDetail(false)
                    } else if (activeAccordion.parentAccordion === accordionTitleConstants.products) {
                        handleMoreItemsClosed(false)
                    }
                }} sx={{ color: '#52575C', fontSize: '34px', cursor: 'pointer', position: 'absolute', top: '0px', left: '-12px' }} />
                <HighlightOffIcon onClick={() => {
                    handleCloseProductDetails(true)
                    handleActiveAccordion({ parentAccordion: '', childAccordion: '' })
                }} sx={{ color: '#52575C', fontSize: '25px', cursor: 'pointer', position: 'absolute', top: '0px', right: '5px' }} />
                <Typography sx={{ fontSize: '14px', fontWeight: '700', display: 'flex', justifyContent: 'center', width: '90%', textAlign: 'center', marginLeft: '10px' }}>{productDetails?.productName}</Typography>
                {/* <Typography sx={{fontSize: '10px', fontStyle: 'italic', display: 'flex', justifyContent: 'center', marginBottom: '10px', color: '#52575C'}}>In project</Typography> */}
            </Box>
            {getView(apiStatus)}
        </>
    )
};

export default ProductDetails;